import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'ms-share-message-hint',
  templateUrl: './hint.component.html',
  imports: [MatIcon],
})
export class ShareMessageHintComponent {
  @Input()
  public type: 'share-message' | 'share-add-friend';
}
